/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SlugAvailability
 */
export interface SlugAvailability {
    /**
     * The slug that was checked
     * @type {string}
     * @memberof SlugAvailability
     */
    slug: string;
    /**
     * Whether the slug is available for use
     * @type {boolean}
     * @memberof SlugAvailability
     */
    available: boolean;
}

/**
 * Check if a given object implements the SlugAvailability interface.
 */
export function instanceOfSlugAvailability(value: object): value is SlugAvailability {
    if (!('slug' in value) || value['slug'] === undefined) return false;
    if (!('available' in value) || value['available'] === undefined) return false;
    return true;
}

export function SlugAvailabilityFromJSON(json: any): SlugAvailability {
    return SlugAvailabilityFromJSONTyped(json, false);
}

export function SlugAvailabilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): SlugAvailability {
    if (json == null) {
        return json;
    }
    return {
        
        'slug': json['slug'],
        'available': json['available'],
    };
}

export function SlugAvailabilityToJSON(json: any): SlugAvailability {
    return SlugAvailabilityToJSONTyped(json, false);
}

export function SlugAvailabilityToJSONTyped(value?: SlugAvailability | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'slug': value['slug'],
        'available': value['available'],
    };
}

